const oGCDSkills        = require("../data/game/ogcd-skills.json");
const Effects           = require("../data/game/effects.json");
const SkillIndirections = require("../data/game/skill-indirections.json");

export default {
	oGCDSkills,
	Effects,
	SkillIndirections,
};
